import Axios from "axios";
var PurSortingService = (function () {
    function PurSortingService() {
    }
    PurSortingService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/sorting/list", { params: params });
    };
    PurSortingService.prototype.getListGoods = function (params) {
        return Axios.get("supplierclientapi/sorting/list_goods", { params: params });
    };
    PurSortingService.prototype.getStatus = function (params) {
        return Axios.get("supplierclientapi/sorting/get_order_status", { params: params });
    };
    PurSortingService.prototype.submit = function (order_id) {
        return Axios.get("supplierclientapi/sorting/audit", {
            params: { order_ids: order_id }
        });
    };
    PurSortingService.prototype.cancel = function (order_id) {
        return Axios.get("supplierclientapi/sorting/cancel", {
            params: { order_ids: order_id }
        });
    };
    PurSortingService.prototype.getUpdateDetail = function (params) {
        return Axios.get("supplierclientapi/sorting/update_info", { params: params });
    };
    PurSortingService.prototype.editSave = function (data) {
        return Axios.post("supplierclientapi/sorting/update", data);
    };
    PurSortingService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/sorting/detail", { params: params });
    };
    PurSortingService.prototype.splitNote = function (data) {
        return Axios.post("/supplierclientapi/sorting/split", data);
    };
    PurSortingService.createInstance = function () {
        PurSortingService.getInstance();
    };
    PurSortingService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return PurSortingService;
}());
export default PurSortingService;
